import approvalInsertTransactionOnUs from './approval-insert-transaction';
import historyTransactionOnUs from './history-insert-transaction';
import insertTransactionOnUs from './insert-transaction';


export default {
  approvalInsertTransactionOnUs,
  historyTransactionOnUs,
  insertTransactionOnUs
};